import React from 'react';
import PropTypes from 'prop-types';

import cl from 'classnames';
import s from './LoadingSpinner.css';

function LoadingSpinner({size, classname, children, delay}) {
  const [showSpinner, setShowSpinner] = React.useState(false);

  React.useEffect(() => {
    let timeoutId = null;

    if (delay) {
      timeoutId = setTimeout(function () {
        setShowSpinner(true);
      }, delay);
    }

    return () => window.clearTimeout(timeoutId);
  }, [delay]);

  return (
    <React.Fragment>
      {showSpinner || !delay ? (
        <>
          <div className={cl(size === 'sm' ? s.SpinnerSmall : s.Spinner, classname)} />
          {children && <div className={s.Text}>{children}</div>}
        </>
      ) : null}
    </React.Fragment>
  );
}

export default LoadingSpinner;

LoadingSpinner.defaultProps = {
  size: 'regular',
};

LoadingSpinner.propTypes = {
  size: PropTypes.string,
  classname: PropTypes.string,
  children: PropTypes.string,
  delay: PropTypes.number,
};
